export default __webpack_public_path__ + "static/media/1915.2b1c8ac4.png";